import React from "react";
import { Container, Typography, Button, Stack, Alert } from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import CategoryTwoToneIcon from "@mui/icons-material/CategoryTwoTone";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import MuPb from "../widgets/MuPb";
import useVerifyToken from "../hooks/useVerifyToken";
import { getErrorResponse } from "../utils/util";
import { useNavigate, useParams } from "react-router-dom";
import { APP_ID } from "../utils/constants";

const ChooseCategoryOptions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useVerifyToken(id);
  if (isLoading) return <MuPb />;
  if (isError) return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  return (
    <Container
      maxWidth="md"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {data?.name}
      </Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Select your option for product categories
      </Typography>

      {/* Options */}
      <Stack direction="column" spacing={3} sx={{ mt: 3, width: "100%" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<CategoryIcon />}
          sx={{ py: 1.5, fontSize: "1rem" }}
          fullWidth
          onClick={() => {
            navigate(`/add-product-categories/single/${id}`);
          }}
        >
          Single Category
        </Button>

        <Button
          variant="contained"
          color="secondary"
          startIcon={<CategoryTwoToneIcon />}
          sx={{ py: 1.5, fontSize: "1rem" }}
          fullWidth
          onClick={() => {
            navigate(`/add-product-categories/double/${id}`);
          }}
        >
          Double Category
        </Button>

        <Button
          variant="contained"
          color="success"
          startIcon={<CategoryOutlinedIcon />}
          sx={{ py: 1.5, fontSize: "1rem" }}
          fullWidth
          onClick={() => {
            navigate(`/add-product-categories/triple/${id}`);
          }}
        >
          Triple Category
        </Button>
      </Stack>
    </Container>
  );
};

export default ChooseCategoryOptions;
